module.exports = __webpack_public_path__ + "static/media/KaTeX_SansSerif-Regular.6c3bd5b5.woff";